import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Question from './Question'

import t from '../utils/lang'

const styles = theme => ({
  root: {
    width: '100%'
  },
  panelHeader: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    flexBasis: '50%',
    flexShrink: 0,
    '@media screen and (max-width: 500px)': {
      fontSize: '0.8rem',
      flexBasis: '100%',
    }
  },
  panelAnswerQuestions: {
    width: '50%',
    textAlign: 'right',
    '@media screen and (max-width: 500px)': {
      display: 'none'
    }
  },
  questionList: {
    display: 'block'
  }
});

class Questions extends Component {
  state = {
    lang: 'en'
  }

  componentDidMount() {
    const { lang } = this.props

    this.setState({ lang: lang ? lang : 'en' })
  }

  componentDidUpdate(prevProps) {
    const { lang } = this.props

    if (lang !== prevProps.lang) {
      this.setState({ lang })
    }
  }

	/*state = {
    expanded: null,
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    })
  }*/

	render() {
    const { lang } = this.state
		const { classes, landlordAndProperty, commercialTerms, buildingStandard, accessibility, answeredQuestions, unansweredQuestions } = this.props

		return (
			<div className={classes.root}>
        <ExpansionPanel defaultExpanded>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.panelHeader}>{t[lang].landlordAndProperty}</Typography>
            <Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.landlordAndProperty} ${t[lang].of} ${landlordAndProperty.length} ${t[lang].answered}`}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.questionList}>
            {landlordAndProperty.length !== 0 && landlordAndProperty.map((question) => (
              <Question key={question.id} question={question} />
            ))}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.panelHeader}>{lang && t[lang].commercialTerms}</Typography>
            <Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.commercialTerms} ${t[lang].of} ${commercialTerms.length} ${t[lang].answered}`}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.questionList}>
            {commercialTerms.length !== 0 && commercialTerms.map((question) => (
              <Question key={question.id} question={question} />
            ))}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.panelHeader}>{lang && t[lang].buildingStandard}</Typography>
            <Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.buildingStandard} ${t[lang].of} ${buildingStandard.length} ${t[lang].answered}`}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.questionList}>
            {buildingStandard.length !== 0 && buildingStandard.map((question) => (
              <Question key={question.id} question={question} />
            ))}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.panelHeader}>{lang && t[lang].accessibility}</Typography>
            <Typography className={classes.panelAnswerQuestions}>{`${answeredQuestions.accessibility} ${t[lang].of} ${accessibility.length} ${t[lang].answered}`}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.questionList}>
            {accessibility.length !== 0 && accessibility.map((question) => (
              <Question key={question.id} question={question} />
            ))}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
		)
	}
}

const arrayToObject = (array) =>
  array.reduce(
    (obj, item, index) => {
      obj[index] = item
      return obj
    }, {}
  )

function mapStateToProps ({ rfpData, questions }) {
  const { lang } = rfpData

  const categorizedQuestions = {
    'landlordAndProperty': Object.values(questions).filter((q) => q.categoryId === "1"),
    'commercialTerms': Object.values(questions).filter((q) => q.categoryId === "2"),
    'buildingStandard': Object.values(questions).filter((q) => q.categoryId === "3"),
    'accessibility': Object.values(questions).filter((q) => q.categoryId === "4"),
  }

  const answeredQuestions = {
    'landlordAndProperty': categorizedQuestions.landlordAndProperty.filter((q) => q.answer !== '').length,
    'commercialTerms': categorizedQuestions.commercialTerms.filter((q) => q.answer !== '').length,
    'buildingStandard': categorizedQuestions.buildingStandard.filter((q) => q.answer !== '').length,
    'accessibility': categorizedQuestions.accessibility.filter((q) => q.answer !== '').length
  }

  const unansweredQuestions = {
    'landlordAndProperty': categorizedQuestions.landlordAndProperty.length - answeredQuestions.landlordAndProperty,
    'commercialTerms': categorizedQuestions.commercialTerms.length - answeredQuestions.commercialTerms,
    'buildingStandard': categorizedQuestions.buildingStandard.length - answeredQuestions.buildingStandard,
    'accessibility': categorizedQuestions.accessibility.length - answeredQuestions.accessibility,
  }

  return {
    landlordAndProperty: categorizedQuestions.landlordAndProperty,
    commercialTerms: categorizedQuestions.commercialTerms,
    buildingStandard: categorizedQuestions.buildingStandard,
    accessibility: categorizedQuestions.accessibility,
    answeredQuestions,
    unansweredQuestions,
    lang
  }
}

export default withStyles(styles)(connect(mapStateToProps)(Questions))


// WEBPACK FOOTER //
// ./src/components/Questions.js